import { ConfigOption } from '@ngx-formly/core';

import { OrderStatusPresetProvider } from './order-status.preset';

export function registerOrderStatusPreset(): ConfigOption {
  return {
    presets: [
      {
        name: 'orderStatus',
        config: new OrderStatusPresetProvider(),
      },
    ],
  };
}
